import { z } from "zod";
import { FACTION_IDS } from "./factions.js";

export const FACTION_LOOT_BONUS_VERSION = "relay-loot-v1";
export const factionLootBonusPolicySchema = z.strictObject({
  version: z.literal(FACTION_LOOT_BONUS_VERSION), percent: z.literal(10), durationMs: z.literal(1800000),
});
export type FactionLootBonusPolicy = z.infer<typeof factionLootBonusPolicySchema>;
export const RELAY_LOOT_BONUS: FactionLootBonusPolicy = { version: FACTION_LOOT_BONUS_VERSION, percent: 10, durationMs: 1800000 };
export const activeFactionLootBonusSchema = z.strictObject({
  factionId: z.enum(FACTION_IDS), version: z.literal(FACTION_LOOT_BONUS_VERSION),
  percent: z.literal(10), expiresAt: z.number().int().nonnegative().max(Number.MAX_SAFE_INTEGER),
});
export type ActiveFactionLootBonus = z.infer<typeof activeFactionLootBonusSchema>;
export const factionLootBonusAwardSchema = z.strictObject({
  version: z.literal(FACTION_LOOT_BONUS_VERSION), credits: z.string().regex(/^(0|[1-9]\d*)$/),
  components: z.number().int().nonnegative(),
});
export type FactionLootBonusAward = z.infer<typeof factionLootBonusAwardSchema>;
